import type { GeneratedColumn } from "building-types/columns/columnGeneratedTypes";
import type { Table } from "common/data/table";

export function columnsOnLevel(levelId: string, columns: Table<GeneratedColumn>): GeneratedColumn[] {
  const levelColumns: GeneratedColumn[] = [];
  for (const columnId in columns) {
    const column = columns[columnId];
    if (column.levelId === levelId) {
      levelColumns.push(column);
    }
  }
  return levelColumns;
}
